import type {
  LoadDTO,
  LoadPhotoSyncStatusDTO,
  LoadStatus,
} from '../data/LoadDTO';

export function isLoadPhotoSyncPendingOnList(
  load: Pick<LoadDTO, 'status' | 'photo_sync_status'>,
): boolean {
  if (load.status === 'picked_up') {
    return !!load.photo_sync_status?.pickup?.is_driver_uploading_photo;
  }

  if (load.status === 'delivered') {
    return !!load.photo_sync_status?.delivery?.is_driver_uploading_photo;
  }

  return false;
}

export function getLoadPhotoSyncCountsFromApi(
  data: LoadPhotoSyncStatusDTO | undefined,
  status: LoadStatus,
): { synced: number; total: number } {
  if (status === 'picked_up') {
    return {
      synced: data?.pickup?.uploaded ?? 0,
      total: data?.pickup?.total ?? 0,
    };
  }

  if (status === 'delivered') {
    return {
      synced: data?.delivery?.uploaded ?? 0,
      total: data?.delivery?.total ?? 0,
    };
  }

  return { synced: 0, total: 0 };
}
